var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { useMemo, useRef, useState } from 'react';
import Suggestions from '@shared/tags/Suggestions';
import { DefaultClassNames, Keys } from '@shared/tags/Tags';
import { MdClose } from 'react-icons/md';
// styled components
import { FormField, FormFieldErrorHelp, FormFieldLabel, FormInputWithBtn, FormTextInput } from '@styled/Form';
import { useTagContext } from '@data/tag/tagContext';
function SelectTag(_a) {
    var label = _a.label, _b = _a.nullLabel, nullLabel = _b === void 0 ? 'Root' : _b, _c = _a.name, name = _c === void 0 ? 'tagSelect' : _c, selectedTagId = _a.selectedTagId, _d = _a.disabledTagIds, disabledTagIds = _d === void 0 ? [] : _d, onChange = _a.onChange, _e = _a.placeholder, placeholder = _e === void 0 ? '' : _e, invalid = _a.invalid, invalidString = _a.invalidString, bottomMargin = _a.bottomMargin, _f = _a.filterByTypes, filterByTypes = _f === void 0 ? [] : _f;
    var tagData = useTagContext().tagData;
    var suggestionsContainerRef = useRef(null);
    var selectedTag = selectedTagId && tagData.tagById[selectedTagId] ? tagData.tagById[selectedTagId] : null;
    var _g = __read(useState(false), 2), showSuggs = _g[0], setShowSuggs = _g[1];
    var _h = __read(useState(-1), 2), selectedIndex = _h[0], setSelectedIndex = _h[1];
    var _j = __read(useState(''), 2), query = _j[0], setQuery = _j[1];
    var _k = __read(useState(false), 2), selectionMode = _k[0], setSelectionMode = _k[1];
    var _l = __read(useState(null), 2), parentTag = _l[0], setParentTag = _l[1];
    var filteredSuggestions = useMemo(function () {
        var ids = tagData.searchTagsAndReturnIds(query, filterByTypes);
        var parent = tagData.tagsByParentId[parentTag ? parentTag.id : 'null'];
        if (parent) {
            var all = tagData.createTagList(parent, 0, {
                searchTagIds: ids,
                disabledTagIds: new Set(disabledTagIds.map(function (tagId) { return tagId; })),
            });
            return all;
        }
        else {
            return [];
        }
    }, [query, tagData, parentTag, showSuggs, disabledTagIds]);
    var resetState = function () {
        setSelectedIndex(-1);
        setShowSuggs(false);
        setQuery('');
        setParentTag(null);
        setSelectionMode(false);
    };
    var selectTag = function (tag) {
        resetState();
        onChange(tag.id);
    };
    var onFocusHandler = function () {
        setShowSuggs(true);
    };
    var handleSuggestionHover = function (i) {
        setSelectedIndex(i);
        setSelectionMode(true);
    };
    var handleSuggestionClick = function (i) {
        selectTag(filteredSuggestions[i].tag);
    };
    var handleParentTagClick = function (i) {
        setParentTag(filteredSuggestions[i].tag);
        setQuery('');
    };
    var handleParentTagBackClick = function () {
        setParentTag(null);
    };
    var handleChange = function (e) {
        if (!showSuggs) {
            setShowSuggs(true);
        }
        setQuery(e.target.value);
    };
    var handleKeyDown = function (e) {
        if (e.keyCode === Keys.ESCAPE) {
            setSelectedIndex(-1);
            setSelectionMode(false);
            setQuery('');
            return;
        }
        if (e.keyCode === Keys.ENTER || e.keyCode === Keys.TAB) {
            if (e.keyCode !== Keys.TAB || query !== '') {
                e.preventDefault();
            }
            if (query !== '' && !query.includes('"')) {
                if (selectionMode) {
                    if (filteredSuggestions[selectedIndex]) {
                        selectTag(filteredSuggestions[selectedIndex].tag);
                        return;
                    }
                }
                var find = filteredSuggestions.find(function (sug) { return sug.name.toLowerCase() === query.toLowerCase(); });
                if (find) {
                    selectTag(find.tag);
                    return;
                }
                return;
            }
        }
        // up arrow
        if (e.keyCode === Keys.UP_ARROW) {
            e.preventDefault();
            // last item, cycle to the top
            if (selectedIndex <= 0) {
                setSelectedIndex(filteredSuggestions.length - 1);
                setSelectionMode(true);
            }
            else {
                setSelectedIndex(selectedIndex - 1);
                setSelectionMode(true);
            }
            return;
        }
        // down arrow
        if (e.keyCode === Keys.DOWN_ARROW) {
            e.preventDefault();
            setSelectedIndex((selectedIndex + 1) % filteredSuggestions.length);
            setSelectionMode(true);
            return;
        }
    };
    var isInvalid = invalidString && invalidString !== '' ? true : false;
    var inputText = (selectedTag === null || selectedTag === void 0 ? void 0 : selectedTag.name) || nullLabel;
    if (showSuggs) {
        inputText = query;
    }
    return (React.createElement(FormField, { "$bottomSpace": bottomMargin },
        React.createElement(FormFieldLabel, null, label),
        React.createElement(FormInputWithBtn, { "$invalid": isInvalid || invalid, "$iconOnTheRight": true },
            React.createElement(FormTextInput, { type: "text", autoComplete: "off", value: inputText, name: name, placeholder: placeholder, onChange: handleChange, onKeyDown: handleKeyDown, onFocus: onFocusHandler, onBlur: function () { return resetState(); } }),
            selectedTag && React.createElement(MdClose, { size: 20, style: { cursor: 'pointer' }, onClick: function () { return onChange(null); } })),
        showSuggs && (React.createElement(Suggestions, { suggestions: filteredSuggestions, selectedIndex: selectedIndex, handleClick: handleSuggestionClick, handleParentTagClick: handleParentTagClick, handleHover: handleSuggestionHover, handleParentTagBackClick: handleParentTagBackClick, classNames: DefaultClassNames, parent: parentTag ? parentTag.name : null, containerRef: suggestionsContainerRef })),
        invalidString && React.createElement(FormFieldErrorHelp, null, invalidString)));
}
export default SelectTag;
